import { RFC } from '../../../types/propTypes'
import { AnimatePresence } from 'framer-motion'
import { InfiniteScrollList } from '../../../components/organisms/organisms'
import { ALL_TITLES } from '../../../assets/data/enums'

type FeedbackUsersProps = {
  searchText: string
}

const FeedbackUsers:RFC<FeedbackUsersProps> = ({ searchText }) => {

  return (
    <div className='w-full mt-4'>
      <AnimatePresence>
        <InfiniteScrollList
          key='infinite_scroll'
          page={ALL_TITLES.PROGRAM_FEEDBACK}
          searchText={searchText}
        />
      </AnimatePresence>
    </div>
  )
}

export default FeedbackUsers